import React from 'react'
import { Grid as BaseGrid, styled } from '@mui/material'

export const Item = styled(({ children, width, ...props }) => (
  <BaseGrid item {...props}>
    {children}
  </BaseGrid>
))`
  width: ${props => props.width};
`

export const Logo = styled('img')`
  height: auto;
  pointer-events: none;
  user-select: none;
  width: 215px;
`

export const LogoLink = styled('a')`
  cursor: pointer;
  float: left;
  margin: 0 20px 0 0;
`

export const Root = styled('div')`
  display: flex;
  height: auto;
  margin: 60px 0 0;
  width: 100%;
`
